module.exports = __webpack_public_path__ + "img/power-pro-premier.6b73f787.svg";